// Historical incident labels for deployments that predate the app tracking history.
// The Google availability roster remains authoritative for the deployment date.
export const LEGACY_DEPLOYMENT_INCIDENTS = [
  { person: 'Gregory Alessandri', date: '2026-08-16', incident: 'Talbot' },
  { person: 'Bud Powell', date: '2026-08-15', incident: 'Talbot' },
];
